<template>
  <div class="page-case">
    <!-- 头部 -->
    <div class="header-box">
      <div class="header-title" id="title1"></div>
      <div class="header-title" id="title2"></div>
    </div>
    <div v-for="(item, index) in imgData" :key="index">
      <!-- 内容部分 Top -->
      <SRF>
        <ContentTop
          :list="getImgList(index, 1)"
          :cate="item.cate"
          @toInfo="toInfo"
        />
      </SRF>
      <!-- 内容部分 Center -->
      <SRF>
        <ContentCenter :list="getImgList(index, 2)" @toInfo="toInfo" />
      </SRF>
      <!-- 内容部分 走马灯 -->
      <SRF>
        <ContentSwiper :list="getImgList(index, 3)" @toInfo="toInfo" />
      </SRF>
    </div>
    <!-- 底部 -->
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import ContentTop from "./components/ContentTop";
import ContentCenter from "./components/ContentCenter";
import ContentSwiper from "./components/ContentSwiper";
import { pageApi } from "@/api";
import _ from "lodash";

export default {
  components: {
    Footer,
    ContentTop,
    ContentCenter,
    ContentSwiper,
  },
  data() {
    return {
      imgData: [],
    };
  },

  created() {
    // console.log(this.$publicData)
  },
  mounted() {
    this.getcaseList();
    new this.Typed("#title1", {
      strings: ["作品是 <span>最佳证言</span>"],
      typeSpeed: 100,
    });

    new this.Typed("#title2", {
      strings: ["从设计到开发，见证实力沉淀的过程"],
      typeSpeed: 100,
    });
  },
  computed: {
    getImgList() {
      return (index, type) => {
        // 检查下标是否越界
        if (!this.imgData[index] || !this.imgData[index].list) {
          return [];
        }
        switch (type) {
          case 1:
            return this.imgData[index].list.slice(0, 2);
          case 2:
            // 检查第三个元素是否存在
            return this.imgData[index].list[2]
              ? [this.imgData[index].list[2]]
              : [];
          case 3:
            return _.chunk(
              JSON.parse(JSON.stringify(this.imgData[index].list)).slice(3),
              4
            );
        }
      };
    },
  },
  methods: {
    async getcaseList() {
      const res = await pageApi.getCaseList();
      this.imgData = res.result;
    },
    toInfo(id) {
      this.$router.push({ name: "caseInfo", query: { id } });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import url("./index.scss");
</style>
